<template>
    <div class="flex mx-2 leading-5 bg-gray-400 rounded-full">
        <button
            @click="updateValue"
            class="flex inline-flex items-center justify-center w-full px-6 py-2 text-base font-medium leading-5 rounded-full focus:bg-blue-600 focus:outline-none focus:text-white "
            :class="{
                'bg-gray-400  text-gray-700': !isChecked,
                'bg-blue-600 text-white': isChecked
            }"
        >
            {{ title }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    methods: {
        updateValue() {
            this.$emit("input", this.title);
        }
    },
    computed: {
        isChecked() {
            return this.value === this.title;
        }
    }
};
</script>

<style></style>
